export default __webpack_public_path__ + "static/AboutWorkAtArtificial-ed29e7e7944843b932b7bee5e3e5c125.png";